// extracted by mini-css-extract-plugin
export default {"button":"i3_sk_Mo","icon":"HUXpxkOm","collapsed":"SciSfuKO"};